import { render, staticRenderFns } from "./OrderItemModalWithAside.vue?vue&type=template&id=ce9a0dae"
import script from "./OrderItemModalWithAside.vue?vue&type=script&lang=js"
export * from "./OrderItemModalWithAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports